<app-button
  (click)="login()"
  class="loginbtn"
  [fullWidth]="true"
  aria-label="Log in using single sign on"
>
    <img src="assets/images/mslogo.png" alt="Ms Logo" />
    <span class="ms-4">Log in with Microsoft</span>
</app-button>
